import { useMemo } from 'react'

import { FavouriteIcon, Timer02Icon } from '@hugeicons/react'
import _ from 'lodash'
import Countdown, { zeroPad } from 'react-countdown'


import { env } from '@/env'

import { NO_TIME_KINDS } from '../../Challenges/config'
import { useLevelContext } from '../../context'

const isDev = env.NODE_ENV == 'development'

export const DigitalProductJourneyLevelHeartsAndCountdown = ({ activity }) => {
  const { hearts, countdownRef, goToOutOfTimeScreen } = useLevelContext()
  const countdownTime = useMemo(() => {
    if (NO_TIME_KINDS.includes(activity?.kind)) return null

    return activity?.time_limit
      ? Date.now() + _.get(activity, 'time_limit', 0) * 1000
      : null
  }, [activity])

  return (
    <div className="flex items-center justify-center px-0 animate-fade-in gap-2">
      {countdownTime && (
        <div
          key={activity.id}
          className="text-sm flex items-center justify-end"
          onClick={() => isDev && goToOutOfTimeScreen()}
        >
          <span
            className="font-bold leading-none text-right block"
            style={{
              width: `${activity.time_limit.toString().length * 10}px`
            }}
          >
            <Countdown
              ref={countdownRef}
              date={countdownTime}
              zeroPadTime={2}
              renderer={({ total, completed }) =>
                completed ? (
                  <span>-</span>
                ) : (
                  <span>{zeroPad(total / 1000)}</span>
                )
              }
              onComplete={goToOutOfTimeScreen}
              autoStart={false}
            />
          </span>
          <Timer02Icon className="text-sky-500 ml-1" variant="duotone" size={22} />
        </div>
      )}
      <div className={`text-sm flex items-center justify-center`}>
        <span className="font-bold leading-none block">{hearts}</span>
        <FavouriteIcon
          className="text-danger ml-1"
          variant="duotone"
          size={22}
        />
      </div>
    </div>
  )
}
